/* @flow */

// Ref: https://www.npmjs.com/package/babel-plugin-conditional-compilation
import typeof BidManagerReal from './bidmanager';
import typeof BidManagerStub from './bidmanager-stub';

let bm: BidManagerReal | BidManagerStub;
('#if ENABLE_HB');
import bmReal from './bidmanager';
bm = bmReal;
('#else');
import bmStub from './bidmanager-stub';
bm = bmStub;
('#endif');
export default bm;
